import { Annoyed, Frown, Meh, Smile, Laugh } from "lucide-react";

export const LEVEL_ICONS = [Annoyed, Frown, Meh, Smile, Laugh];
export const LEVEL_COLORS = ["#F87171", "#FB923C", "#FBBF24", "#4ADE80", "#2DD4BF"];

export const SmileLevel = ({ level, size = 18, testid }) => {
  const lv = Math.max(0, Math.min(4, Math.round(level)));
  const Icon = LEVEL_ICONS[lv];
  return <Icon size={size} style={{ color: LEVEL_COLORS[lv] }} data-testid={testid} aria-label={`level ${lv}`} />;
};
